<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item
      v-for="(item,idx)  in titles"
      :to="{ path: item.path}"
      :key="idx"
    >{{item.meta.pageTitle}}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script type="text/ecmascript-6">
export default {
  computed: {
    titles: {
      get() {
        var matched = this.$route.matched;
        let domain = this.$store.state.examInfo.currentExamInfo.domain;
        var titles = [];
        const first = matched[1];
        titles.push({
          name: "main",
          path: `/e/${domain}/login`,
          meta: { pageTitle: "首页" }
        });
        titles.push(first);
        return titles;
      }
    }
  }
};
</script>

<style>
.el-breadcrumb {
  margin-bottom: 20px;
}
.el-breadcrumb__inner {
  font-size: 10px;
}
</style>